import cloneDeep from "lodash-es/cloneDeep"

import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"
import { RoomsAPIType } from "shared/types/Project"
import { Room } from "shared/types/Room"

import { transformProjectChildren } from "entities/projects/graphql/projectResponseTransformer"

export function transformRoom(room: Room): Room {
  return { ...room, children: transformProjectChildren(room.children) }
}

export const roomResponseTransformer = createResponseTransformer(json => {
  // json-api-serializer declares `deserialize` as `any`; the room shape is
  // asserted once here so nothing downstream has to.
  const deserialized = cloneDeep(
    serializer.deserialize(RoomsAPIType, transformJsonApiResponse(json))
  ) as Room
  return transformRoom(deserialized)
})
